// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"20b02330","453":"f907893c","495":"cf91ff85","706":"dedb9c59","728":"21a56505","840":"ecc9f158","879":"52643a54","968":"4a57771f"}[chunkId] + ".chunk.js";
};